<template>
  <div class="course-content-view">
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Course content')"></breadcrumbs>
         <div class="col-lg-6 col-5 text-right">
            <base-button
              :disabled="!orderingChanged"
              @click="applyOrdering"
              type="success">
              {{ $t('Apply ordering') }}
            </base-button>
        </div>
      </div>
    </base-header>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <block-draggable-list el-type="block" v-model="courseContent"/>
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
  import Breadcrumbs from "../../../Layout/Breadcrumbs.vue";
  import Spinner from 'vue-spinner-component/src/Spinner.vue';
  import BlockDraggableList from "../../../../components/Draggable/BlockDraggableList";
  import {deepCopy} from "../../../../utils";
  import {createNamespacedHelpers} from 'vuex';

  const {mapGetters, mapActions} = createNamespacedHelpers('course/content');

  export default {
    name: "CourseContent",
    metaInfo() {
      return {
        title: "Course content",
        htmlAttrs: {
          lang: 'ru'
        }
      }
    },
    data() {
      return {
        orderingChanged: false,
        waiterKeyword: 'course content loader'
      }
    },
    components: {
      BlockDraggableList,
      Breadcrumbs,
      Spinner
    },
    mounted() {
      this.fetchData();
    },
    computed: {
      ...mapGetters({
        getContent: 'getContent',
      }),
      courseContent: {
        get() {
          return deepCopy(this.getContent);
        },
        set(value) {
          this.updateContentOrdering({value});
        }
      }
    },
    watch: {
      '$route': 'fetchData',
      'getContent': function (val, oldval) {
        if (!this.isEmptyList(oldval) && !this.isEmptyList(val)) {
          this.orderingChanged = true;
        }
      }
    },
    methods: {
      ...mapActions({
        loadContent: 'load',
        updateContentOrdering: 'updateContentOrdering',
        saveOrdering: 'saveOrdering'
      }),

      async fetchData() {
        this.$wait.start(this.waiterKeyword);
        await this.loadContent({urlParams: this.$route.params});
        this.$wait.end(this.waiterKeyword);
      },

      async applyOrdering() {
        this.$wait.start(this.waiterKeyword);
        await this.saveOrdering({urlParams: this.$route.params});
        this.orderingChanged = false;
        this.$wait.end(this.waiterKeyword);
      },

       isEmptyList(list) {
        return Array.isArray(list) && list.length === 0;
      },
    },
  };

</script>

<style lang="scss">
   .course-content-view {
     max-width: 1100px;
     margin: auto;
   }
</style>
